import React from 'react'
import range from 'lodash.range'

import { SelectInput, SelectInputProps } from '../SelectInput'

const variants: { [key: string]: (props: DayInputProps) => SelectInputProps } = {
  'day-numbers': props => ({
    width: '5rem',
    options: range(props.numberOfDays).map(day => ({
      label: String(day + 1).padStart(2, '0'),
      value: day + 1,
    })),
  }),
  'day-names': () => ({
    options: [
      { label: 'Monday', value: 0 },
      { label: 'Tuesday', value: 1 },
      { label: 'Wednesday', value: 2 },
      { label: 'Thursday', value: 3 },
      { label: 'Friday', value: 4 },
      { label: 'Saturday', value: 5 },
      { label: 'Sunday', value: 6 },
    ],
  }),
}

export interface DayInputProps extends SelectInputProps {
  numberOfDays?: number
  variantOptions?: 'day-numbers' | 'day-names'
}

export const DayInput = (props: DayInputProps) => {
  const variantProps = variants[props.variantOptions](props)

  return <SelectInput {...variantProps} {...props} />
}

DayInput.defaultProps = {
  numberOfDays: 31,
  variantOptions: 'day-numbers',
}

export default DayInput
